import type { DeskTicketRule } from '@detect/shared';

export type ListKey = 'sensorKeys' | 'datapoints' | 'severities' | 'clientIds' | 'resourceIds' | 'alertRuleIds' | 'detectionModes' | 'conditionKinds';

export const LIST_KEYS: ListKey[] = ['sensorKeys', 'datapoints', 'severities', 'clientIds', 'resourceIds', 'alertRuleIds', 'detectionModes', 'conditionKinds'];

/** Rules that cannot be saved as they stand (the server enforces the same rule). */
export function ruleProblems(rules: readonly DeskTicketRule[]): string[] {
  const problems: string[] = [];
  for (const r of rules) {
    if (r.name.trim() === '') problems.push('Every ticket rule needs a name.');
    const m = r.match;
    const filters = LIST_KEYS.filter(
      (k) => (m[k]?.length ?? 0) > 0
    );
    for (const k of LIST_KEYS) if ((m[k]?.length ?? 0) > 50) problems.push(`"${r.name || 'Untitled'}": at most 50 values per filter.`);
    if (m.all !== true && filters.length === 0) problems.push(`"${r.name || 'Untitled'}" selects nothing: pick at least one filter, or choose “every alert”.`);
  }
  if (rules.length > 50) problems.push('At most 50 ticket rules.');
  return problems;
}

